import { IBaseEnumEntity } from '../../base/interfaces/IBaseEnumEntity';

export class AttributeOption  implements IBaseEnumEntity {
    /**
     *
     */
    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
        this.value = `"${name}"`;
    }
    id: string;
    name: string;
    value: string;
}
